import { toast } from "react-toastify";

export default class AlertService {
  static success(message: string) {
    return toast.success(message, {
      position: toast.POSITION.BOTTOM_RIGHT,
      theme: "colored",
    });
  }

  static error(message: string) {
    return toast.error(message, {
      position: toast.POSITION.BOTTOM_RIGHT,
      theme: "colored",
    });
  }

  static info(message: string) {
    return toast.info(message, {
      position: toast.POSITION.BOTTOM_RIGHT,
      theme: "colored",
    });
  }

  static warning(message: string) {
    return toast.warning(message, {
      position: toast.POSITION.BOTTOM_RIGHT,
      theme: "colored",
    });
  }
}
